var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"text-align":"center","color":"red","font-weight":"bold"},attrs:{"colspan":"3"}},[_vm._v("\n    Campaign Deleted\n")])}
var staticRenderFns = []

export { render, staticRenderFns }